/**
 * V4官网首页入口
 * @version V4
 * @since 2026-01-20
 */

import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import WebApp from './App.vue';

const webApp = createApp(WebApp);
webApp.use(ElementPlus);
webApp.mount('#web-app');
